import ClaniceNaProjektuCardItem from "./ClaniceNaProjektuCardItem";

const ClaniceNaProjektuCards = ({ clanice }) => {
  return (
    <div>
      {clanice.map((clanica) => (
        <ClaniceNaProjektuCardItem key={clanica.clanicaID} clanica={clanica} />
      ))}
    </div>
  );
};

export default ClaniceNaProjektuCards;
